import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import ButtonGroup from '../ButtonGroup';
import Button from '../Button';
import Dropdown from '../Dropdown';
import Menu, { MenuItem } from '../Menu';
import Squeezer from '../Squeezer';
import ResponsiveContext from '../ResponsiveContext';

var alphaSort = function alphaSort(a, b) {
  return a > b ? 1 : -1;
};
/**
 *  `Segmented Control` is a group of several [Buttons](#!/Button)
 * each of which functions as a mutually exclusive option.
 * @since 0.0.68
 */


var SegmentedControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SegmentedControl, _Component);

  function SegmentedControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SegmentedControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SegmentedControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: _this.props.selected,
      monoWidth: 0
    });

    _defineProperty(_assertThisInitialized(_this), "isCompact", false);

    _defineProperty(_assertThisInitialized(_this), "rootRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "adjustMonospaced", function () {
      var _this$props = _this.props,
          baseClassName = _this$props.baseClassName,
          monospaced = _this$props.monospaced;

      if (monospaced) {
        var monoWidth = 0;

        _this.rootRef.current.querySelectorAll(".".concat(baseClassName, "__button")).forEach(function (el) {
          monoWidth = Math.max(monoWidth, el.getBoundingClientRect().width);
        });

        if (monoWidth !== _this.state.monoWidth) {
          _this.setState({
            monoWidth: monoWidth
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      return function () {
        var _this$props2 = _this.props,
            multiple = _this$props2.multiple,
            onChange = _this$props2.onChange;
        var selected = _this.state.selected;
        var newSelected;

        if (multiple) {
          newSelected = selected ? selected.slice() : [];

          if (!selected || !(selected instanceof Array) || selected.indexOf(value) === -1) {
            newSelected.push(value);
          } else {
            newSelected.splice(selected.indexOf(value), 1);
          }

          newSelected.sort(alphaSort);
        } else {
          newSelected = value;
        }

        if (selected instanceof Array) {
          selected.sort(alphaSort);
        }

        if (JSON.stringify(newSelected) !== JSON.stringify(selected)) {
          _this.setState({
            selected: newSelected
          });

          onChange(newSelected);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "compact", function () {
      if (_this.isCompact) {
        return false;
      }

      _this.isCompact = true;

      _this.forceUpdate();

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "uncompact", function () {
      if (!_this.isCompact) {
        return false;
      }

      _this.isCompact = false;

      _this.forceUpdate();

      return true;
    });

    return _this;
  }

  _createClass(SegmentedControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustMonospaced();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.adjustMonospaced();
    }
  }, {
    key: "isResponsive",
    value: function isResponsive() {
      return this.context === undefined ? this.isCompact : this.context;
    }
  }, {
    key: "renderControl",
    value: function renderControl() {
      var _this$props3 = this.props,
          buttons = _this$props3.buttons,
          multiple = _this$props3.multiple;
      var hasIcons = buttons.some(function (_ref) {
        var icon = _ref.icon;
        return !!icon;
      });

      if (!hasIcons && !multiple && this.isResponsive()) {
        return this.renderDropdown();
      }

      return this.renderButtonGroup();
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this2 = this;

      var _this$props4 = this.props,
          buttons = _this$props4.buttons,
          onChange = _this$props4.onChange;
      var selected = this.state.selected;

      var _ref2 = buttons.find(function (button) {
        return button.value === selected;
      }) || {},
          title = _ref2.title;

      var menu = React.createElement(Menu, null, buttons.map(function (_ref3) {
        var title = _ref3.title,
            value = _ref3.value,
            buttonProps = _objectWithoutProperties(_ref3, ["title", "value"]);

        var menuItemProps = {};

        if (onChange !== null) {
          menuItemProps.onClick = _this2.handleChange(value);
        }

        return React.createElement(MenuItem, _extends({
          key: value
        }, buttonProps, menuItemProps), title);
      }));
      return React.createElement(Dropdown, {
        menu: menu
      }, title);
    }
  }, {
    key: "renderButtonGroup",
    value: function renderButtonGroup() {
      var _this3 = this;

      var _this$props5 = this.props,
          buttons = _this$props5.buttons,
          monospaced = _this$props5.monospaced,
          multiple = _this$props5.multiple,
          onChange = _this$props5.onChange,
          ghost = _this$props5.ghost,
          baseClassName = _this$props5.baseClassName;
      var _this$state = this.state,
          selected = _this$state.selected,
          monoWidth = _this$state.monoWidth;
      var isCollapsed = this.state.compact;
      return React.createElement(ButtonGroup, {
        className: "".concat(baseClassName, "__button-group")
      }, buttons.map(function (_ref4) {
        var value = _ref4.value,
            title = _ref4.title,
            buttonProps = _objectWithoutProperties(_ref4, ["value", "title"]);

        // uncontrolled
        var handler = {};

        if (onChange !== null) {
          handler.onClick = _this3.handleChange(value);
        }

        var buttonSelected = false;

        if (multiple && selected && selected instanceof Array && selected.indexOf(value) !== -1) {
          buttonSelected = true;
        } else if (!multiple && selected === value) {
          buttonSelected = true;
        }

        buttonProps.className = classNames(buttonProps.className, "".concat(baseClassName, "__button"));

        if (!isCollapsed && monospaced && monoWidth) {
          buttonProps.style = _objectSpread({
            width: monoWidth
          }, buttonProps.style);
        }

        return React.createElement(Button, _extends({
          key: value,
          selected: buttonSelected,
          ghost: ghost
        }, handler, buttonProps), title);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props6 = this.props,
          label = _this$props6.label,
          labelPlacement = _this$props6.labelPlacement,
          buttons = _this$props6.buttons,
          monospaced = _this$props6.monospaced,
          multiple = _this$props6.multiple,
          selectedProp = _this$props6.selected,
          onChange = _this$props6.onChange,
          inline = _this$props6.inline,
          ghost = _this$props6.ghost,
          className = _this$props6.className,
          baseClassName = _this$props6.baseClassName,
          props = _objectWithoutProperties(_this$props6, ["label", "labelPlacement", "buttons", "monospaced", "multiple", "selected", "onChange", "inline", "ghost", "className", "baseClassName"]);

      var isCollapsed = this.isResponsive();
      return React.createElement(ResponsiveContext.Provider, {
        value: isCollapsed
      }, React.createElement(Squeezer, {
        compact: this.compact,
        uncompact: this.uncompact,
        innerRef: function innerRef(el) {
          _this4.rootRef.current = el;
        }
      }, function (_ref5) {
        var _classNames;

        var ref = _ref5.ref;
        return React.createElement("div", _extends({
          ref: ref,
          className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--inline"), inline), _defineProperty(_classNames, "".concat(baseClassName, "--collapsed"), isCollapsed), _defineProperty(_classNames, "".concat(baseClassName, "--vertical"), label && labelPlacement === 'top'), _classNames), className)
        }, props), label && React.createElement("div", {
          className: "".concat(baseClassName, "__label")
        }, label), _this4.renderControl());
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var selected = props.selected,
          multiple = props.multiple;
      var prevSelected = state.prevSelected;
      var nextState = {
        selected: state.selected
      };

      if (selected !== prevSelected) {
        nextState.selected = selected;
      }

      if (multiple && nextState.selected && !(nextState.selected instanceof Array)) {
        nextState.selected = [nextState.selected];
      }

      nextState.prevSelected = selected;
      return nextState;
    }
  }]);

  return SegmentedControl;
}(Component);

SegmentedControl.propTypes = {
  /**
   * Label
   * @since 0.0.68
   */
  label: PropTypes.node,

  /**
   * Where to place label
   * @since 0.0.68
   */
  labelPlacement: PropTypes.oneOf(['top', 'left']),

  /**
   * Array of buttons to display (every array item must contain an unique "value" property)
   * @since 0.0.68
   */
  buttons: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    title: PropTypes.node
  })).isRequired,

  /**
   * Monospaced version of buttons (all button would have the same width).
   * Attention: using it with buttons dynamic update may cause to wrong behavior!
   * @since 0.0.68
   */
  monospaced: PropTypes.bool,

  /**
   * Multiple selected options version (any number of buttons can be selected)
   * @since 0.0.68
   */
  multiple: PropTypes.bool,

  /**
   * Selected value or an array of values (for multiple version).
   * Used in controlled version or as default value in uncontrolled version (with onChange property)
   * @since 0.0.68
   */
  selected: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]).isRequired,

  /**
   * On change selection callback for uncontrolled mode.
   * @since 0.0.68
   */
  onChange: PropTypes.func,

  /**
   * Should component displays as inline element?
   * @since 0.0.68
   */
  inline: PropTypes.bool,

  /**
   * Use buttons with transparent background (ghost buttons)
   * @since 2.3.0
   */
  ghost: PropTypes.bool,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
SegmentedControl.defaultProps = {
  label: null,
  labelPlacement: 'top',
  monospaced: false,
  multiple: false,
  onChange: null,
  inline: false,
  ghost: false,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "segmented-control")
};
SegmentedControl.contextType = ResponsiveContext;
export default SegmentedControl;